"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpolate = void 0;
/**
 * Interpolates values into a template string
 * Example usage
 * const user = { name: "Charlie", city: "New York", profile: { age: 30 } };
 * const template = "User ${name} lives in ${city}. Age: ${profile.age}. Role: ${role:-Guest}.";
 * const result = interpolate(template, user);
 * console.log(result); // Output: User Charlie lives in New York. Age: 30. Role: Guest.
 * @param template String with placeholders in format ${key} or ${key:-defaultValue}
 * @param values Object containing values to replace placeholders
 * @returns String with placeholders replaced with values
 */
var interpolate = function (template, values) {
    return template.replace(/\${(.*?)(?::-(.+?))?}/g, function (match, path, defaultValue) {
        // Handle nested properties using path
        var value = path
            .split('.')
            .reduce(function (obj, key) {
            return obj && obj[key] !== undefined ? obj[key] : undefined;
        }, values);
        // Return value, default value, or original placeholder
        if (value !== undefined)
            return String(value);
        if (defaultValue !== undefined)
            return defaultValue;
        return match; // Keep original placeholder if no value or default
    });
};
exports.interpolate = interpolate;
